export const environment = {
  production: true,
  connection: {
    name: 'Schuberth Softline (Test)',
    host: 'https://softline-test.schuberth.at',
    port: 443,
    basePath: '/api',
  },
  androidUpdateRepository: '',
};
